import { styled } from "@mui/material/styles";
import axios, { AxiosError } from "axios";
import { useSnackbar } from "notistack";
import { useMutation, useQuery } from "react-query";
import { API_URL } from "../consts";
import LoadingButton from "@mui/lab/LoadingButton";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import { Box, Button, Stack } from "@mui/material";
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";
import { queryClient } from "../App";
import { oraPrenotaStore } from "../oraPrenotaStore";

const Input = styled("input")({
  display: "none",
});

export function Certificato(props: {
  userId: number | string;
  nome: string;
  cognome: string;
  onUpload: () => void;
}) {
  const { userId, nome, cognome, onUpload } = props;
  const { enqueueSnackbar } = useSnackbar();

  const { data } = useQuery<{ presente: boolean }>(
    ["users/certificatoOk", userId],
    () => axios.get(API_URL + "users/certificatoOk/" + userId).then((res) => res.data),
    { refetchOnWindowFocus: false, staleTime: 1e4 }
  );

  const handleInputChange = (event: any) => {
    const data = new FormData();

    data.append("id", "" + userId);
    data.append("file", event.target.files[0]);

    mutate(data);
  };

  const { isLoading, mutate } = useMutation(
    (data: any) => {
      return axios.post(API_URL + "users/uploadCert", data, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
    },
    {
      onSuccess: (data) => {
        queryClient.invalidateQueries();
        enqueueSnackbar("Certificato caricato", { variant: "success" });
        onUpload();
      },
      onError: (error: AxiosError) => {
        enqueueSnackbar(error?.response?.data?.message ?? "Si è verificato un errore!", {
          variant: "error",
        });
      },
    }
  );

  const token = oraPrenotaStore((state) => state.token);

  async function handleDownload() {
    let anchor = document.createElement("a");
    document.body.appendChild(anchor);
    let file = API_URL + "users/certificato/" + userId;

    let headers = new Headers();
    if (token === "") {
      enqueueSnackbar("Autorizzazione Scaduta! Effettuare il log in", {
        variant: "error",
      });
      return;
    }

    headers.append("Authorization", "Bearer " + token);

    const response = await fetch(file, { headers });

    if (response.status >= 300) {
      enqueueSnackbar("Certificato non trovato!", {
        variant: "error",
      });
      return;
    }
    const blobby = await response.blob();

    let objectUrl = window.URL.createObjectURL(blobby);

    const contentDisposition = response.headers.get("content-disposition");
    let extension = "";
    if (contentDisposition) {
      const arr = contentDisposition.split(".");
      extension = arr[arr.length - 1].replace("'", "");
    }

    anchor.href = objectUrl;
    anchor.download = "certificato_" + nome + "_" + cognome + "." + extension;
    anchor.click();

    window.URL.revokeObjectURL(objectUrl);
  }

  return (
    <Box>
      <label htmlFor="upload-button-file">
        <Input id="upload-button-file" multiple type="file" onChange={handleInputChange} />
        <Stack direction="row" gap={2}>
          <LoadingButton
            color="secondary"
            variant="contained"
            component="span"
            loading={isLoading}
            startIcon={<CloudUploadIcon />}
          >
            Carica Certificato
          </LoadingButton>

          {data?.presente && (
            <Button
              onClick={handleDownload}
              variant="contained"
              color="secondary"
              startIcon={<CloudDownloadIcon />}
            >
              Scarica Certificato
            </Button>
          )}
        </Stack>
      </label>
    </Box>
  );
}
